import { Directive, OnInit, HostListener } from '@angular/core';

@Directive({
    selector: '[stickyHeaderDirectiveCommonArea]'
})
export class StickyHeaderDirectiveCommonArea implements OnInit {


    ngOnInit() {
    }

    constructor() {}

    @HostListener('scroll', ['$event']) private onScroll($event: any): void {
        sessionStorage.setItem('scrollTopCommonArea', $event.target.scrollTop);
    }   
}